export default {
  psw: "Şifre",
  topFive: "En İyi Beş",
  confPsw: "Şifreyi Onayla",
  newPsw: "Yeni Şifre",
  email: "E-posta",
  emailId: "E-posta",
  submit: "Gönder",
  cancel: "İptal",
  
  faqs: "SSS",
  users: "Kullanıcılar",
  appUser: "Uygulama Kullanıcıları",
  app_users: "Uygulama Kullanıcıları",
  dimitraAdmin: "Dimitra Yöneticisi",
  admin_users: "Yönetici Kullanıcılar",
  search: "arama",
  searchBy: "arama {type}",
  firstName: "İsim",
  lastName: "Soyisim",
  mobile: "Cep telefonu",
  mobileNumber: "Cep Telefonu Numarası",
  department: "Departman",
  role: "Rol",
  status: "Durum",
  autoCondition: "Otomatik Durum",
  permission: "İzinler",
  activity_log: "Faaliyet Günlükleri",
  profile_auth: "Profil kimlik doğrulama",
  countryCode: "Ülke kodu",
  selectDept: "Departman Seçiniz",
  selectRole: "Rol Seçiniz",
  edit: "Düzenle",
  update: "Güncelleme",
  delete: "Sil",
  view: "Görmek",
  deactivate: "Devre dışı bırak",
  activate: "Etkinleştir",
  serverError: "Bir şeyler ters gitti. Lütfen bir süre sonra deneyin.",
  minute: "Dakika",
  perHour: "Saat başına",
  day: "Gün",
  enterDescription: "Açıklamanızı buraya girin",
  enterHere: "Buraya Girin",
  enterMobile: "Cep telefonu numarasını girin",
  phoneRequired: "Cep telefonu gereklidir",
  phoneValid: "Cep telefonu geçerli olmalıdır",
  unableToUpdate: "Güncellenemiyor",
  membershipPlans: "Üyelik Planları",
  byWeek: "Haftaya Göre",
  byMonth: "Aya Göre",
  byYear: "Yıla Göre",
  custom: "Özel",
  name: "İsim",
  regionState: "Bölge/ Eyalet",
  provinceState: "İl/Eyalet",
  cityTown: "Şehir/Kasaba",
  membershipValidity: "Üyelik geçerlilik süresi",
  exportAsCSV: "CSV olarak dışa aktar",
  filterBy: "Şuna göre filtrele",
  comingSoon: "Çok Yakında",
  userRole: "Kullanıcı Rolü",
  additionalInformationRequired: "Gerekli Ek Bilgiler",
  back: "Geri",
  approve: "Onaylandı",
  reject: "Reddet",
  username: "Kullanıcı Adı",
  phone: "Telefon",
  roleAssigned: "Atanan Rol",
  roleRequested: "Talep Edilen Rol",
  requestedDate: "Talep Edilen Tarih",
  updateRoleRequest: "Rol Güncelleme Talebi",
  message: "mesaj",
  selectFarmers: "Çiftçileri Seç",
  faqSection: {
    createFaq: "SSS OLUŞTURUN",
    createTopic: "Konu Oluştur",
    selectTopic: "Konu Seçin",
    faqQuestion: "SSS Sorusu",
    faqAnswer: "SSS Cevabı",
    uploadImgVid: "Resim/Video Yükleyin",
    disInFaq: "SSS bölümünde görüntüle",
    editFaq: "SSS Düzenle",
    topicName: "Konu Adı",
    parentTopic: "Ebeveyn Konusu",
    editTopic: "Konuyu Düzenle",
    createSection: "Please create section first",
    createTopicFirst: "Please create topic first",
    questionReq: "SSS sorusu gereklidir",
    answerReq: "SSS cevabı gereklidir",
  },
  reports: {
    male: "Erkek",
    female: "Kadın",
    other: "Diğer",
    farmerName: "Çiftçi Adı",
    farmerProdChart: "Çiftçi Üretim Tablosu",
    production: "Üretim",
    byProduction: "Üretime göre",
    byName: "İsme göre",
    descending: "Azalan",
    ascending: "Artan",
    buyingStationProdChart: "Satın Alma İstasyonu Üretim Tablosu",
    buyingStation: "Satın Alma Merkezi",
    buyingStationName: "Satın Alma Merkezi Adı",
    dryMilling: "Kuru Öğütme",
    dryMillingName: "Kuru Taşlama Adı",
    dryMillingProdChart: "Kuru Taşlama Üretim Tablosu",
    view: "Görüntüle",
    date: "Tarih",
    reports: "Raporlar",
  },
  traceability: {
    traceability: "İzlenebilirlik",
    coffeeTraceabilityMngmnt: "Kahve İzlenebilirlik Yönetimi",
    traceabilityPage: "İzlenebilirlik Sayfası",
    labelDesigner: "Etiket Tasarımcısı",
    additionalInformation: "Ek Bilgiler",
    info1:
      "Ürününüzün ek logoları hakkında bilgi verin. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
    addSlogan: "Slogan Ekle",
    additionalLogos: "Ek Logolar",
    title: "Başlık",
    description: "Açıklama",
    mapLink: "Harita Bağlantısı",
    websiteLink: "Web Sitesi Bağlantısı",
    addMedia: "Medya Ekle",
    uploadImageVideo: "Görüntü/Video Yükle",
    origin: "Menşei",
    info2:
      "Ürününüzün menşe ülkesi hakkında bilgi verin. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
    countryImage: "Ülke Görüntüsü",
    institutionalInfo: "Kurumsal Bilgiler",
    info3:
      "Şirketiniz/kooperatifiniz hakkında bilgi verin, tüketicilere yaptığınız ilgili çalışmaları anlatın. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
    cooperativeLogo: "Kooperatif Logosu",
    traceabilityIntro: "İzlenebilirlik Tanıtımı",
    info4:
      "Bu bölüm, tüketiciye kahve üretim ve işleme tarihçesine erişim sağlayacaktır. İzlenebilirliğin şirketiniz/kooperatifiniz ve dünya için önemini açıklayın.",
    addLabel: "Etiket Ekle",
    chooseTitle: "Başlık Seç",
    chooseLabelDesign: "Etiket Tasarım Şablonu Seç",
    uploadYourLogo: "Logonuzu Yükleyin",
    info5:
      "Talimatlar: Görüntü boyutu en az 1000 x 1000 piksel kare olmalıdır. Arka plan renkleriyle uyumlu olması için Saydam PNG seçebilirsiniz.",
    chooseTemplateColors: "Şablon Renklerini Seçin",
    backgroundColor: "Arka Plan Rengi",
    foregroundColor: "Ön Plan Rengi",
    labelStatus: "Etiket Durumu",
    inactive: "Devre Dışı",
    download: "İndir",
    enterLabelTitle: "Etiket Başlığı Girin",
  },
  cacaoTraceability: {
    traceability: "İzlenebilirlik",
    cacaoTraceabilityMngmnt: "Kakao İzlenebilirlik Yönetimi",
    traceabilityPage: "İzlenebilirlik Sayfası",
    labelDesigner: "Etiket Tasarımcısı",
    additionalInformation: "Ek Bilgiler",
    info1:
      "Ürününüzün ek logoları hakkında bilgi verin. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
    addSlogan: "Slogan Ekle",
    additionalLogos: "Ek Logolar",
    title: "Başlık",
    description: "Açıklama",
    mapLink: "Harita Bağlantısı",
    websiteLink: "Web Sitesi Bağlantısı",
    addMedia: "Medya Ekle",
    uploadImageVideo: "Görüntü/Video Yükle",
    origin: "Menşei",
    info2:
      "Ürününüzün menşe ülkesi hakkında bilgi verin. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
    countryImage: "Ülke Görüntüsü",
    institutionalInfo: "Kurumsal Bilgiler",
    info3:
      "Şirketiniz/kooperatifiniz hakkında bilgi verin, tüketicilere yaptığınız ilgili çalışmaları anlatın. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
    cooperativeLogo: "Kooperatif Logosu",
    traceabilityIntro: "İzlenebilirlik Tanıtımı",
    info4:
      "Bu bölüm, tüketiciye kakao üretim ve işleme tarihçesine erişim sağlayacaktır. İzlenebilirliğin şirketiniz/kooperatifiniz ve dünya için önemini açıklayın.",
    addLabel: "Etiket Ekle",
    chooseTitle: "Başlık Seç",
    chooseLabelDesign: "Etiket Tasarım Şablonu Seç",
    uploadYourLogo: "Logonuzu Yükleyin",
    info5:
      "Talimatlar: Görüntü boyutu en az 1000 x 1000 piksel kare olmalıdır. Arka plan renkleriyle uyumlu olması için Saydam PNG seçebilirsiniz.",
    chooseTemplateColors: "Şablon Renklerini Seçin",
    backgroundColor: "Arka Plan Rengi",
    foregroundColor: "Ön Plan Rengi",
    labelStatus: "Etiket Durumu",
    inactive: "Devre Dışı",
    download: "İndir",
    enterLabelTitle: "Etiket Başlığı Girin",
  },
  setting: {
    profileAuthSetting: "Profil kimlik doğrulama ayarları",
    logInOutSetting: "Giriş/Çıkış Ayarları",
    autoLogout: "Otomatik Çıkış",
    unsuccessfulLoginAttempt: "Başarısız Giriş Denemeleri",
    unsuccessfulLoginLockPeriod: "Başarısız oturum açma kilitlenme süresi",
    passCriteriaSetup: "Şifre Kriteri Ayarı",
    passLength: "Parola uzunluğu",
    noUniquePassRequired: "Gerekli benzersiz parola sayısı",
    maxPassAge: "Maksimum parola süresi",
    acceptableRangeOfChars: "Kabul edilebilir karakter aralığı ",
    upperCase: "Büyük harf",
    lowerCase: "Küçük harf",
    numbers: "sayılar",
    specialChars: "Özel karakterler",
    uniqueSymbols: "Özgün semboller",
    loadingData: "Veri Yükleniyor...",
    currency: "Para Birimi",
    codeActivationTime: "Kod Etkinleştirme Süresi",
    changeGlobalSetting: "Global Ayarları Değiştir",
    globalSetting: "Global Ayarlar",
    generalSetting: "Genel Ayarlar",
    hour: "Saat",
    days: "Gün",
    minutes: "Dakika",
    perDay: "Günlük",
    perHour: "Saat başına",
    customised: "Özelleştirilmiş",

    smallFarm: "Küçük çiftlik",
    inclusive: "Dahil",
    from: "Başlangıç",
    to: "Bitiş",
    mediumFarm: "Orta büyüklükte çiftlik",
    largeFarm: "Büyük çiftlik",
    requiredMessage: "Bu alan gereklidir",
    nonNegativeMessage: "Bu alan negatif olamaz",
    fieldToGreaterThanFrom: "Bu alan 'Başlangıç' alanından büyük olmalıdır",
    fieldToGreaterThanFromMedium: "Bu alan küçük çiftliğin 'Bitiş' alanından büyük olmalıdır",
    fieldToGreaterThanMediumTo: "Bu alan orta büyüklükte çiftliğin 'Bitiş' alanından büyük olmalıdır",
  },
  coffeeData: {
    windBreaker: "Rüzgar Kırıcı Ağaç",
    horticultureInfo: "Bahçe Ağacı",
    shadeTree: "Gölgelik Ağaç",
    coffeeVariety: "Kahve Çeşitleri",
    coffeeSpecies: "Kahve Türleri",
    updateWindBreaker: "rüzgarKırıcı Ağaç Türünü Güncelle",
    addWindBreaker: "Yeni windBreaker Ağaç Türü Ekleme",
    updateHorticultureInfo: "bahçeağacıBilgi Ağaç Türünü Güncelle",
    addHorticultureInfo: "Yeni bahçeağacıBilgi Ağaç Türü Ekle",
    updateShadeTree: "gölgelikAğaç Ağaç Türünü Güncelle",
    addShadeTree: "Yeni shadeTree Ağaç Türü Ekle",
    updateCoffeeVariety: "kahveÇeşidi Ağaç Türünü Güncelle",
    addCoffeeVariety: "Yeni kahveÇeşidi Ağaç Türü Ekle",
    deleteVarietyTitle: "Çeşidi Sil",
    deleteVarietyMessage: "Çeşidi silmek istediğinizden emin misiniz?",
    updateCoffeeSpecie: "Kahve Türünü Güncelle",
    deleteSpecieTitle: "Türü Sil",
    deleteSpecieMessage: "Türü silmek istediğinizden emin misiniz?",
    addCoffeeSpecie: "Yeni Kahve Türü Ekleyin",
    variety: "Çeşitlilik",
    selectVariety: "Çeşit Seçiniz",
    deleteCoffeeRecord: "Kaydı silmek istediğinizden emin misiniz?",
    deleteCoffeeData: "Kahve Verilerini Sil",
    topicRequired: "Konu adı gereklidir",
    coffeeAddSuccess: "Kahve Türü başarıyla eklendi.",
    treeTypeSuccess: "Ağaç türü başarıyla eklendi.",
    treeTypeUpdateSuccess: "Ağaç türü başarıyla güncellendi.",
    coffeeVarietySuccess: "Kahve çeşidi başarıyla eklendi.",
    coffeeSpecieSuccess: "Kahve türü başarıyla güncellendi.",
    nameRequired: "İsim gerekli",
    notFound: "Yönetici Kahvesi verisi bulunamadı",
  },
  plantation: {
    farmerName: "Çiftçi Adı",
    phoneNumber: "Telefon Numarası",
    plantationName: "Çiftlik Adı",
    farm: "Çiftlik",
    location: "Konum",
    updatePlantationStatus: "Çiftlik Durumunu Güncelle",
    update: "ΕΚΣΥΓΧΡΟΝΙΖΩ",
  },
  dashboardReports: {
    appDataReports: "Uygulama Veri Raporları",
    reports: "Raporlar",
  },
  activationKey: {
    enterActivationKey: "Yeni bir kullanıcı kaydetmek için lütfen aktivasyon anahtarını girin",
    activationKeyLimit: "Aktivasyon anahtarı çok kısa",
    countryRequired: "Ülke gereklidir",
    activationKey: "Aktivasyon Anahtarları",
    appointSalesManager: "Satış Müdürü Atayın",
    appointManager: "MÜDÜR ATAMA",
    salesManAppSuccess: "SATIŞ MÜDÜRÜ BAŞARIYLA ATANDI",
    uploadData: "ATANAN VERİ CSV'SİNİ YÜKLE",
    uploadUserData: "Lütfen kullanıcı veri dosyasını yükleyin.",
    downloadCsv: "(Yapıyı görmek için örnek .csv dosyasını indirin)",
    downloadSample: "Örnek dosyayı indirin",
    dragDrop: "Dosyayı sürükleyip bırakın veya tarayın.",
    browse: "göz atın",
    yourFile: "senin dosyan",
    incorectFileType: "Yanlış dosya türü",
    somethingWentWrong: "Bir şeyler ters gitti",
    fileUploadedSuccess: "Dosya Başarıyla Yüklendi",
    countRecords: "Sayım Kayıtları",
    sendNow: "ŞİMDİ GÖNDER",
    fileName: "dosya-adı",
    assignActKey: "Etkinleştirme Anahtarlarının Atanması",
    actKeyAssSucc: "Etkinleştirme anahtarları başarıyla atandı",
    viewActKey: "AKTIVASYON ANAHTARLARINI GÖRÜNTÜLE",
    actKeyQuota: "Aktivasyon Anahtarları Kontenjanı",
    genActKey: "Oluşturulan Aktivasyon Anahtarları",
    remActKey: "Kalan Aktivasyon Anahtarları",
    penUsed: "Bekleyen ve Kullanılmış Anahtarlar",
    activationKeyAss: "Aktivasyon Anahtarları Atandı",
    activationKeyUnass: "Etkinleştirme Anahtarları Atanmamış",
    keysAct: "Anahtarlar Etkinleştirildi",
    uploadedFiles: "Yüklenen Dosyalar",
    generateActKey: "AKTIVASYON ANAHTARLARI OLUŞTURMA",
    showData: "Verileri Göster",
    noDataFound: "Tarih Bulunamadı",
    pleaseGenKey:
      'Lütfen "Aktivasyon Anahtarları Oluştur" seçeneğini kullanarak aktivasyon anahtarını oluşturun',
    noActKey: "Henüz aktivasyon anahtarı oluşturulmadı",
    buttonAbv: "yukarıdaki düğme",
    numberOfActKey: "Aktivasyon Anahtarı Sayısı",
    membershipRole: "Üyelik Rolü",
    membershipPlan: "Üyelik Planı",
    comments: "Yorumlar",
    genKeys: "ANAHTARLARI OLUŞTUR",
    keysNum: "Anahtar Numarası",
    phoneNumber: "Telefon Numarası",
    keysStatus: "Anahtar Durumu",
    ActivationKeysList: "Etkinleştirme Anahtarları Listesi",
    back: "GERİ",
    usingActKeys: "Etkinleştirme Anahtarları Oluştur'u kullanarak",
    pleaseGenActKeyss: "Lütfen aktivasyon anahtarlarını oluşturun",
    clearAllFilters: "TÜM FİLTRELERİ TEMİZLE",
    salesManager: "Satış Müdürü",
    clearAll: "TÜMÜNÜ TEMİZLE",
    generatedBy: "Şu Kişi Tarafından Oluşturuldu:",
    numberOfKeys: "Anahtar Sayısı",
    action: "Eylem",
    viewAllUplFiles: "YÜKLENEN TÜM DOSYALARI GÖRÜNTÜLE",
    bulkUploadUsers: "TOPLU KULLANICI YÜKLEME",
    noActivationKeyFound: "Etkinleştirme Anahtarı Bulunamadı",
    pleaseCreateAdminRole: 'Lütfen yukarıdaki "Yönetici Rolü Oluştur"',
    btnCreateAdmin: "düğmesini kullanarak yönetici rolü oluşturun",
    donwloadAsCsv: "CSV olarak indirin",
    donwloadAsPdf: "PDF olarak indir",
    assignSalesManager: "Satış Müdürü Atama",
    shareViaEmail: "E-posta ile Paylaş",
    sendEmail: "E-POSTA GÖNDER",
    emailSend: "E-POSTA BAŞARIYLA GÖNDERILDI",
    donwload: "İndir",
    deleteFile: "Dosya Sil",
    invalidFileData: "Dosyadaki etkinleştirme anahtarı verileri geçersiz",
    continue: "Devam et",
    description: "Açıklama",
    selectWeek: "Hafta Seçin",
    confirm: "ONAYLA",
    selectMonth: "Ay Seçiniz",
    selectDateRange: "Tarih Aralığı Seçin",
    regionDistrict: "Bölge/İlçe",
    address: "Adres",
    familyTribe: "Aile",
    website: "Web sitesi",
    deactivated: "Devre dışı bırakıldı",
    active: "Aktif",
    country: "Ülke",
    farmer: "Çiftçi",
    commodity: "Emtia",
    quantity: "Miktar",
    unit: "Birim",
    price: "Fiyat",
    save: "KAYDETMEK",
    stateIsReq: "Ülke gereklidir",
    cityIsReq: "Şehir gereklidir",
    addressIsReq: "Adres gereklidir",
    membershipTypeReq: "Üyelik türü gereklidir",
    extendedReasonReq: "Uzatma gerekçesi gereklidir",
    numberOfDaysReq: "Gün sayısı gereklidir",
    extendedMembershipValidity: "Genişletilmiş Üyelik Geçerlilik Süresi",
    set: "SET",
    adminRole: "Yönetici Rolleri",
    typeMsg: "Type your message here",
    errors: {
      cannotBeBlank: "Bu alan boş bırakılamaz",
      required: "Bu alan zorunludur",
      somethingWentWrong: "Bir şeyler ters gitti!!!",
    },
    loadingData: "Veri Yükleniyor...",
    markAsRead: "Okundu olarak işaretle",
    membership: {
      remainingDays: "Kalan Gün Sayısı",
      type: "Üyelik Türü",
      validity: "Üyelik Geçerliliği",
      validityLength: {
        custom: "Özel",
        expired: "Süresi doldu",
        oneTo8Months: "1-8 ay",
        lessThan1Month: "1 Aydan Az",
        moreThan1Month: "1 yıldan fazla",
        sixTo12Months: "6-12 Ay arası",
      },
    },
    of: "'nın",
    ok: "TAMAM",
    statusItems: {
      closed: "Kapalı",
      open: "Açık",
    },
    orderByItems: {
      all: "Tümü",
      dateAscending: "Artan Ödeme",
      dateDescending: "Azalan Ödeme",
      dueDate: "Geçerlilik Tarihi",
      high: "Yüksek",
      low: "Düşük",
      medium: "Orta",
    },
    orderBy: "Şuna göre sipariş et:",
    select: "Seçiniz",
    type: "Tip",
    uploadImageVideo: "Resim/Video Yükleme",
    user: "Kullanıcılar",
    userName: "Kullanıcı Adı",
    usersSelected: "Kullanıcı Seçimi",
    topics: "Konular",
    date: "Tarih",
    addNew: "Yeni Ekle",
    exportAsCsv: "CSV olarak dışa aktar",
    noData: "Veri Bulunamadı",
    login: {
      welcomeMsg: "Hoş geldiniz! Giriş yapın",
      info: "Kimlik bilgilerinizi girin..",
      forgot: "Şifrenizi mi unuttunuz?",
      btn: "Giriş Yap",
      unableToLogin: "Giriş Yapılamıyor",
    },
    forgot: {
      info_l1:
        "Lütfen hesabınızla ilişkilendirilmiş e-posta adresini girin. Şifre bilgileriniz e-posta adresinize gönderilecektir.",
      info_l2:
        "Lütfen hesabınızla ilişkili cep telefonu numaranızı girin. Şifre detayları telefon numaranıza gönderilecektir.",
      info_l3:
        "Please choose one of the following options to receive instructions on how to reset your password",
      forgotQ: "Şifrenizi mi unuttunuz?",
      loginNow: "Şimdi Giriş Yapın",
      resetSucc: "Şifreniz başarıyla sıfırlandı",
      resetSucc_l2:
        "Şimdi hesabınıza giriş yapmak için yeni şifrenizi kullanabilirsiniz.",
      entPsw: "Lütfen yeni şifrenizi giriniz..",
      resetPsw: "Şifrenizi Sıfırlayın",
      resendOTP: "Tek kullanımlık şifreyi yeniden gönder",
      enterCorrectOTP: "Lütfen doğru tek kullanımlık şifreyi girin..",
      enterOTP:
        "Lütfen e-posta/mobil üzerinden alınan tek kullanımlık şifreyi girin.",
      backToLoginPage: "Back to Login page",
      recieveCodeFalse: " I didn't receive the code",
    },
    dashboard: "Kontrol paneli",
    userslist: {
      createNewUser: "Create a New User",
      chooseCreateType: "Please choose one of the following options:",
      addNewUser: "Yeni Kullanıcı Ekle",
      editUser: "Kullanıcıyı Düzenle",
      addNewAdmin: "Yönetici Kullanıcı Ekle",
      userLoading: "Kullanıcılar yükleniyor... Lütfen bekleyin",
      noUser: "KULLANICI YOK",
      extendVal: "GEÇERLİLİĞİ UZAT",
      extendReason: "Uzatma Nedeni",
      extendReasonMsg: "Üyelik uzatma nedenini belirtin",
      exportAsCSV: "CSV olarak dışa aktar",
      membershipType: "Üyelik Türü",
      membershipValidity: "Üyelik Geçerliliği",
      regionState: "Bölge/ Eyalet",
      cityTown: "Şehir/Kasaba",
      clearAll: "TÜMÜNÜ TEMİZLE",
      search: "arama",
    },
    addEdituser: {
      firstNameRequired: "İsim gereklidir",
      firstNameOllyAlpha: "İsim yalnızca harf içerebilir",
      firstNameLimit: "İsim 50 karakterden az olmalıdır",
      lastNameRequired: "Soyadı gereklidir",
      lastNameOllyAlpha: "Soyadı yalnızca harf içerebilir",
      lastNameLimit: "Soyadı 50 karakterden az olmalıdır",
      emailReuired: "E-posta gereklidir",
      emailInvalid: "Invalid email format.",
      mobileRequired: "Geçersiz e-posta biçimi",
      invalidMobile: "Geçersiz cep telefonu numarası biçimi.",
      pswRequired: "Şifre gereklidir",
      deptRequired: "Bölüm gereklidir",
      roleRequired: "Rol gereklidir",
      countryRequired: "Ülke Kodu gereklidir",
      userUpdated: "Kullanıcı Güncellendi",
      userNotUpdated: "Kullanıcı Güncellenmedi",
      activateAct: "Hesabı Etkinleştir",
      deactivateAct: "Hesabı Devre Dışı Bırak",
      userActivated: "Kullanıcı Etkinleştirildi",
      userDeactivated: "Kullanıcı Devre Dışı Bırakıldı",
      deactivateUser: "Kullanıcıyı Devre Dışı Bırak",
      deactivateMsg:
        "Kullanıcı durumunu değiştirmek istediğinizden emin misiniz?",
      userAdded: "Kullanıcı Eklendi",
      userNotAdded: "Kullanıcı Eklenmedi",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "Kullanıcıyı Düzenle",
    },
    permissions: {
      savePermissions: "IZINLERI KAYDET",
      moduleName: "Modül adı",
      view: "Görüntüle",
      create: "Oluştur",
      update: "Güncelle",
      delete: "Sil",
      permissionsUpdated: "İzinler Güncellendi",
      permissionsNotUpdated: "İzinler Güncellenmedi",
      selectMembership: "Üyelik Seçiniz",
      noPermMsg:
        "İzinlerinizi görüntülemek için lütfen yukarıdaki 'Üyelik Türü' açılır menüsünü kullanarak üyelik türünü seçin",
      selectRoleMsg: "İzinleri göstermek için lütfen yukarıdaki Rolü seçin",
    },
    logs: {
      time: "Saat",
      username: "Kullanıcı Adı",
      role: "Rol",
      terminalID: "Bağlantı Noktası Kimliği",
      moduleAccessed: "Modüle Erişildi",
      typeOfAccess: "Erişim Türü",
      activityLogDetails: "Etkinlik günlüğü ayrıntıları",
      userId: "Kullanıcı Kimliği",
      lastLogin: "Son Giriş",
      geoAccPoint: "Coğrafi erişim noktası",
      ipAdd: "IP adresi",
      filesAccessed: "Erişilen dosyalar",
      funAccessed: "Fonksiyona erişildi",
      webUrl: "Web sayfası URL'si",
      unsuccAtmp: "Başarısız Giriş denemesi",
      view: "Görüntüle",
      membershipType: "Üyelik Türü",
    },
    profileSetting: {
      profileAuthSettings: "Profil kimlik doğrulama ayarları",
      changeSettings: "Ayarları Değiştir",
      loginLogoutSettings: "Giriş/Çıkış Ayarları",
      autoLogout: "Otomatik Çıkış",
      unsuccAtmp: "Başarısız Giriş Denemeleri",
      unsuccLoginLock: "Başarısız oturum açma kilitlenme süresi",
      pswCrisetup: "Şifre Kriteri Ayarı",
      pswLength: "Parola uzunluğu",
      noOfUniquePsw: "Gerekli benzersiz parola sayısı ",
      maxPswAge: "Maksimum parola süresi",
      AccRangeOfchars: "Kabul edilebilir karakter aralığı",
      upperCase: "Büyük harf",
      lowerCase: "Küçük harf",
      numbers: "Sayılar",
      specialChars: "Özel karakterler",
      settingsUpdated: "Ayarlar Güncellendi",
      settingsNotUpdated: "Ayarlar Güncellenmedi",
    },
    dashboardSection: {
      modules: "Modüller",
      allowances: "Ücretler",
      maxUserAllowed: "İzin Verilen Maksimum Kullanıcı Sayısı ",
      satelliteReportsAllowed: "Uydu Raporlarına İzin Verildi",
      advanceReport: "İzin Verilen Gelişmiş Raporlar",
      subscriptionUpTo: "Şuna Kadar Abonelik:",
      roleAllowed: "İzin Verilen Roller",
      moduleAllowed: "İzin Verilen Modüller",
      registeredUsers: "Kayıtlı Kullanıcılar",
      validMemberships: "Geçerli Üyelikler",
      activeUsers: "Aktif Kullanıcılar",
      deactivatedUsers: "Devre Dışı Bırakılan Kullanıcılar",
      membershipValidity: "Üyelik geçerlilik süresi",
      lessThan1Month: "1 Aydan Az",
      months1to6: "1-6 Ay arası",
      months6to12: "6-12 Ay arası",
      moreThan1Year: "1 yıldan fazla",
      cropOverview: "Mahsule Genel Bakış",
      plantations: "Çiftlikler ",
      coffeeData: "Kahve Verileri",
      availableModules: "Mevcut Modüller",
      roleList: "Çiftçi, Satın Alım Merkezi, Depo",
      memberData: "Üye Verileri",
      userType: "Kullanıcı Türü",
      registered: "Kayıtlı",
      offlineUsers: "Çevrimdışı Kullanıcılar",
      lessThanOneMonth: "< 1 Ay",
      cacaoData: "Kakao Verileri",
      dryCacao: "Kuru Kakao",
      traceability: "İzlenebilirlik",
    },
    adminRoles: {
      adminRoles: "Yönetici Rolleri",
      roleName: "Rol Adı",
      description: "Açıklama",
      viewPermissions: "İzinleri Görüntüle",
      createAdminRole: "YÖNEİCİ ROLÜ OLUŞTUR",
      enterDesHere: "Açıklamanızı buraya girin",
      deleteRole: "Rol Silme",
      deleteMsg: "Rolü silmek istediğinizden emin misiniz?",
      roleReq: "Rol adı gereklidir",
      roleLimit: "Rol adı 15 karakterden az olmalıdır",
      desReq: "Açıklama gereklidir",
      desLimit: "Açıklama 40 karakter veya daha az olmalıdır",
      roleSuccess: "Rol başarıyla oluşturuldu",
      editAdminRole: "Yönetici Rolünü Düzenle",
      roleUpdated: "Rol Güncellendi",
      noRole: "Yönetici Rolü Bulunamadı",
      noRoleMsg:
        "Lütfen yukarıdaki 'Yönetici Rolü Oluştur' düğmesini kullanarak yönetici rolü oluşturun",
    },
    membershipplanSection: {
      defaultPlan: " Varsayılan Plan",
      planType: "Plan Türü",
      planDuration: "Plan Süresi",
      planFee: "Plan Ücreti",
      satelliteReport: "Uydu Raporları",
      advanceReport: "AVANS RAPORU",
      addMembership: "Üyelik Ekle",
      addMembershipPlan: "Üyelik Planı Ekle",
      editMembershipPlan: "Üyelik Planını Düzenle",
      accessSetelite: "Uydu Raporlarına Erişim (5 raporluk set)",
      accessAdvanceReport: "Gelişmiş Raporlara Erişim",
      memPlanReq: "Üyelik Planı gereklidir",
      memPlanReqLimit: "Üyelik planı 20 karakterden az olmalıdır",
      SatelliteReq: "Uydu Raporu gereklidir",
      advancedReportReq: "Gelişmiş Rapor gereklidir",
      durationReq: "Üyelik Süresi gereklidir",
      feeReq: "Üyelik Ücreti gereklidir",
      cantLesThenZero: "0'dan küçük olamaz",
      roleReq: "Kullanıcı rolü gereklidir",
    },
    tickets: {
      actions: {
        create: "Bilet Oluştur",
        delete: "bilet sil",
        edit: "bileti düzenle",
      },
      areaOfRequest: "Talep Alanı",
      assignee: "Vekil",
      deleteTicket: {
        confirmation: "{0} biletini silmek istediğinizden emin misiniz?",
      },
      dueDate: "Geçerlilik Tarihi",
      filters: {
        ticketFor: "Şunun için bilet:",
      },
      form: {
        ticketType: {
          admin: "Dimitra Admin için Destek Bileti Oluştur",
          user: "Uygulama Kullanıcısı için Destek Bileti Oluştur",
        },
      },
      markAsRead: "Okundu olarak işaretle",
      messages: {
        created: {
          success: "Bilet başarıyla oluşturuldu",
        },
        deleted: {
          success: "Bilet başarıyla silindi",
        },
      },
      noData: "Bilet Bulunamadı!",
      noDataHelpText: `Henüz{0}size atanmış bir bilet yok. Başlamak için bu ekranın üst kısmındaki "Bilet Oluştur" düğmesine{1} tıklayın.`,
      pickerInMenu: "Menü Seçici",
      priority: {
        high: "Yüksek",
        label: "Öncelik",
      },
      reply: "Yanıtla",
      requestedDateTime: "Talep edilen tarih ve saat",
      requestorDetails: "Talep sahibi bilgileri",
      requestorEmail: "Talep Eden E-posta",
      subject: "konu",
      ticketsForItems: {
        all: "Tümü",
        dimitraAdmin: "Dimitra Yöneticisi",
        multipleUsers: "Çoklu Kullanıcılar",
        singleUser: "Tek Kullanıcı",
      },
      title: "Biletler",
    },
    roleRequest: {
      roleRequest: "Rol Talebi",
      userRole: "Kullanıcı Rolü",
      approve: "Onaylandı",
      reject: "Reddet",
      username: "Kullanıcı Adı",
      email: "E-posta",
      phone: "Telefon",
      roleAssigned: "Atanan Rol",
      roleRequested: "Talep Edilen Rol",
      requestedDate: "Talep Edilen Tarih",
      updateRoleRequest: "Rol Güncelleme Talebi",
      message: "mesaj",
      update: "Güncelleme",
    },
    faqSection: {
      createFaq: "SSS OLUŞTURUN",
      createTopic: "Konu Oluştur",
      selectTopic: "Konu Seçin",
      faqQuestion: "SSS Sorusu",
      faqAnswer: "SSS Cevabı",
      uploadImgVid: "Resim/Video Yükleyin",
      disInFaq: "SSS bölümünde görüntüle",
      editFaq: "SSS Düzenle",
      topicName: "Konu Adı",
      parentTopic: "Ebeveyn Konusu",
      editTopic: "Konuyu Düzenle",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "Çiftçi Adı",
      farmerProdChart: "Çiftçi Üretim Tablosu",
      production: "Üretim",
      byProduction: "Üretime göre",
      byName: "İsme göre",
      descending: "Azalan",
      ascending: "Artan",
      buyingStationProdChart: "Satın Alma İstasyonu Üretim Tablosu",
      buyingStation: "Satın Alma Merkezi",
      buyingStationName: "Satın Alma Merkezi Adı",
      dryMilling: "Kuru Öğütme",
      dryMillingName: "Kuru Taşlama Adı",
      dryMillingProdChart: "Kuru Taşlama Üretim Tablosu",
      view: "Görüntüle",
      date: "Tarih",
      reports: "Raporlar",
    },
    traceability: {
      traceability: "İzlenebilirlik",
      coffeeTraceabilityMngmnt: "Kahve İzlenebilirlik Yönetimi",
      traceabilityPage: "İzlenebilirlik Sayfası",
      labelDesigner: "Etiket Tasarımcısı",
      additionalInformation: "Ek Bilgiler",
      info1:
        "Ürününüzün ek logoları hakkında bilgi verin. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
      addSlogan: "Slogan Ekle",
      additionalLogos: "Ek Logolar",
      title: "Başlık",
      description: "Açıklama",
      mapLink: "Harita Bağlantısı",
      websiteLink: "Web Sitesi Bağlantısı",
      addMedia: "Medya Ekle",
      uploadImageVideo: "Görüntü/Video Yükle",
      origin: "Menşei",
      info2:
        "Ürününüzün menşe ülkesi hakkında bilgi verin. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
      countryImage: "Ülke Görüntüsü",
      institutionalInfo: "Kurumsal Bilgiler",
      info3:
        "Şirketiniz/kooperatifiniz hakkında bilgi verin, tüketicilere yaptığınız ilgili çalışmaları anlatın. Bu bilgi, kahve izlenebilirlik sayfasında kamuya açık olacaktır.",
      cooperativeLogo: "Kooperatif Logosu",
      traceabilityIntro: "İzlenebilirlik Tanıtımı",
      info4:
        "Bu bölüm, tüketiciye kahve üretim ve işleme tarihçesine erişim sağlayacaktır. İzlenebilirliğin şirketiniz/kooperatifiniz ve dünya için önemini açıklayın.",
      addLabel: "Etiket Ekle",
      chooseTitle: "Başlık Seç",
      chooseLabelDesign: "Etiket Tasarım Şablonu Seç",
      uploadYourLogo: "Logonuzu Yükleyin",
      info5:
        "Talimatlar: Görüntü boyutu en az 1000 x 1000 piksel kare olmalıdır. Arka plan renkleriyle uyumlu olması için Saydam PNG seçebilirsiniz.",
      chooseTemplateColors: "Şablon Renklerini Seçin",
      backgroundColor: "Arka Plan Rengi",
      foregroundColor: "Ön Plan Rengi",
      labelStatus: "Etiket Durumu",
      inactive: "Devre Dışı",
      download: "İndir",
      enterLabelTitle: "Etiket Başlığı Girin",
    },
    cacaoTraceability: {
      traceability: "İzlenebilirlik",
      cacaoTraceabilityMngmnt: "Kakao İzlenebilirlik Yönetimi",
      traceabilityPage: "İzlenebilirlik Sayfası",
      labelDesigner: "Etiket Tasarımcısı",
      additionalInformation: "Ek Bilgiler",
      info1:
        "Ürününüzün ek logoları hakkında bilgi verin. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
      addSlogan: "Slogan Ekle",
      additionalLogos: "Ek Logolar",
      title: "Başlık",
      description: "Açıklama",
      mapLink: "Harita Bağlantısı",
      websiteLink: "Web Sitesi Bağlantısı",
      addMedia: "Medya Ekle",
      uploadImageVideo: "Görüntü/Video Yükle",
      origin: "Menşei",
      info2:
        "Ürününüzün menşe ülkesi hakkında bilgi verin. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
      countryImage: "Ülke Görüntüsü",
      institutionalInfo: "Kurumsal Bilgiler",
      info3:
        "Şirketiniz/kooperatifiniz hakkında bilgi verin, tüketicilere yaptığınız ilgili çalışmaları anlatın. Bu bilgi, kakao izlenebilirlik sayfasında kamuya açık olacaktır.",
      cooperativeLogo: "Kooperatif Logosu",
      traceabilityIntro: "İzlenebilirlik Tanıtımı",
      info4:
        "Bu bölüm, tüketiciye kakao üretim ve işleme tarihçesine erişim sağlayacaktır. İzlenebilirliğin şirketiniz/kooperatifiniz ve dünya için önemini açıklayın.",
      addLabel: "Etiket Ekle",
      chooseTitle: "Başlık Seç",
      chooseLabelDesign: "Etiket Tasarım Şablonu Seç",
      uploadYourLogo: "Logonuzu Yükleyin",
      info5:
        "Talimatlar: Görüntü boyutu en az 1000 x 1000 piksel kare olmalıdır. Arka plan renkleriyle uyumlu olması için Saydam PNG seçebilirsiniz.",
      chooseTemplateColors: "Şablon Renklerini Seçin",
      backgroundColor: "Arka Plan Rengi",
      foregroundColor: "Ön Plan Rengi",
      labelStatus: "Etiket Durumu",
      inactive: "Devre Dışı",
      download: "İndir",
      enterLabelTitle: "Etiket Başlığı Girin",
    },
    setting: {
      profileAuthSetting: "Profil kimlik doğrulama ayarları",
      logInOutSetting: "Giriş/Çıkış Ayarları",
      autoLogout: "Otomatik Çıkış",
      unsuccessfulLoginAttempt: "Başarısız Giriş Denemeleri",
      unsuccessfulLoginLockPeriod: "Başarısız oturum açma kilitlenme süresi",
      passCriteriaSetup: "Şifre Kriteri Ayarı",
      passLength: "Parola uzunluğu",
      noUniquePassRequired: "Gerekli benzersiz parola sayısı",
      maxPassAge: "Maksimum parola süresi",
      acceptableRangeOfChars: "Kabul edilebilir karakter aralığı ",
      upperCase: "Büyük harf",
      lowerCase: "Küçük harf",
      numbers: "sayılar",
      specialChars: "Özel karakterler",
      uniqueSymbols: "Özgün semboller",
      loadingData: "Veri Yükleniyor...",
      currency: "Para Birimi",
      codeActivationTime: "Kod Etkinleştirme Süresi",
      changeGlobalSetting: "Global Ayarları Değiştir",
      globalSetting: "Global Ayarlar",
      generalSetting: "Genel Ayarlar",
      hour: "Saat",
      days: "Gün",
      minutes: "Dakika",
      perDay: "Günlük",
      perHour: "Saat başına",
      customised: "Özelleştirilmiş",
    },
    coffeeData: {
      windBreaker: "Rüzgar Kırıcı Ağaç",
      horticultureInfo: "Bahçe Ağacı",
      shadeTree: "Gölgelik Ağaç",
      coffeeVariety: "Kahve Çeşitleri",
      coffeeSpecies: "Kahve Türleri",
      updateWindBreaker: "rüzgarKırıcı Ağaç Türünü Güncelle",
      addWindBreaker: "Yeni windBreaker Ağaç Türü Ekleme",
      updateHorticultureInfo: "bahçeağacıBilgi Ağaç Türünü Güncelle",
      addHorticultureInfo: "Yeni bahçeağacıBilgi Ağaç Türü Ekle",
      updateShadeTree: "gölgelikAğaç Ağaç Türünü Güncelle",
      addShadeTree: "Yeni shadeTree Ağaç Türü Ekle",
      updateCoffeeVariety: "kahveÇeşidi Ağaç Türünü Güncelle",
      addCoffeeVariety: "Yeni kahveÇeşidi Ağaç Türü Ekle",
      deleteVarietyTitle: "Çeşidi Sil",
      deleteVarietyMessage: "Çeşidi silmek istediğinizden emin misiniz?",
      updateCoffeeSpecie: "Kahve Türünü Güncelle",
      deleteSpecieTitle: "Türü Sil",
      deleteSpecieMessage: "Türü silmek istediğinizden emin misiniz?",
      addCoffeeSpecie: "Yeni Kahve Türü Ekleyin",
      variety: "Çeşitlilik",
      selectVariety: "Çeşit Seçiniz",
      deleteCoffeeRecord: "Kaydı silmek istediğinizden emin misiniz?",
      deleteCoffeeData: "Kahve Verilerini Sil",
      topicRequired: "Konu adı gereklidir",
      coffeeAddSuccess: "Kahve Türü başarıyla eklendi.",
      treeTypeSuccess: "Ağaç türü başarıyla eklendi.",
      treeTypeUpdateSuccess: "Ağaç türü başarıyla güncellendi.",
      coffeeVarietySuccess: "Kahve çeşidi başarıyla eklendi.",
      coffeeSpecieSuccess: "Kahve türü başarıyla güncellendi.",
      nameRequired: "İsim gerekli",
      notFound: "Yönetici Kahvesi verisi bulunamadı",
    },
    plantation: {
      farmerName: "Çiftçi Adı",
      phoneNumber: "Telefon Numarası",
      plantationName: "Çiftlik Adı",
      farm: "Çiftlik",
      location: "Konum",
      updatePlantationStatus: "Çiftlik Durumunu Güncelle",
      update: "ΕΚΣΥΓΧΡΟΝΙΖΩ",
    },
    surveyBuilder: {
      addNewSurvey: "Yeni Anket Ekle",
      surveyTitle: "Anket Başlığı",
      surveyName: "Anket Adı",
      surveyDescription: "Anket Açıklaması",
      describeSurvey: "Anketi Tanımla",
      enableScheduling: "Zamanlamayı Etkinleştir",
      selectedDate: "Seçilen Tarih",
      multiStepSurvey: "Çoklu Adımlı Anket",
      multiStepSurveyDetails:
        "Bir adımdaki soru sayısına göre, anketin tüm soruları gruplanacak ve adımlar halinde görüntülenecektir.",
      multiStep: "Çoklu Adım",
      noQuestionEachStep: "Her Adımdaki Soru Sayısı",
      surveyStatus: "Anket Durumu",
      surveyStatusDetails:
        "Anket yalnızca sorular ekledikten sonra etkinleştirilebilir. Bir anketi etkinleştirmek, çiftçilerin gönderilere başlamasına izin verecektir.",
      selectUsers: "Kullanıcıları Seç",
      selectUsersDetails:
        "Eğer kullanıcı seçimi devre dışı bırakılırsa, anket tüm kullanıcılara açık olacaktır. Kullanıcıları seçmeyi etkinleştirirseniz, bir sonraki adımda birden fazla kullanıcı seçebilirsiniz.",
      linkWithFarms: "Çiftliklerle Bağlantı Kur",
      linkWithFarmsDetails:
        "Eğer etkinleştirilirse, anket bireysel çiftliklerle ilişkilendirilecektir. Bir çiftçinin birden fazla çiftliği varsa, her çiftliğin kendi anketi olacaktır.",
      enabled: "Etkin",
      disabled: "Devre Dışı",
      cancel: "İptal",
      next: "İleri",
      surveySettings: "Anket Ayarları",

      selectSurveyUsers: "Anket Kullanıcılarını Seç",
      selectToProceed: "Devam etmek için lütfen kullanıcı(lar) seçin",
      searchUsers: "Kullanıcıları Ara",
      usersSelected: "Kullanıcılar Seçildi",
      conditional: "Şartlı",
      autoConditional: "Otomatik Şartlı",
      userName: "Kullanıcı Adı",
      email: "E-posta",
      membershipType: "Üyelik Türü",
      membershipValidity: "Üyelik Geçerliliği",
      membershipRemainingDays: "Kalan Gün Sayısı",
      membershipRole: "Üye Rolü",
      accountProgress: "Hesap İlerlemesi",
      status: "Durum",
      active: "Aktif",
      deactivated: "Devre Dışı",
      continue: "Devam",
      questions: "Sorular",
      responses: "Cevaplar",
      deleteSurvey: "Anketi Sil",
      editSurvey: "Anketi Düzenle",
      type: "Tür",
      compulsory: "Zorunlu",
      createSurvey: "Anket Oluştur",
      surveyBuilder: "Anket Oluşturucu",
      surveyList: "Anket Listesi",
      farm: "Çiftlik",
      responseDate: "Cevap Tarihi",
      viewSurvey: "Anketi Görüntüle",
      question: "Soru",
      settings: "Ayarlar",
      addQuestion: "Soru Ekle",
      surveysSubmitted: "Gönderilen Anketler",
      surveyDetail: "Anket Detayı",
      conditionStatus: "Şart Durumu",
      conditionStatusDesc:
        "Koşulları karşılayan kullanıcılar otomatik olarak anket için uygun hale gelecektir.",

      endSurvey: "Anketi Sonlandır",
      publishSurvey: "Anketi Yayınla",
      copy: "Kopyala",
      view: "Görüntüle",
      startDate: "Başlangıç Tarihi",
      endDate: "Bitiş Tarihi",
      chooseDate: "Tarih Seç",
      select: "Seç",
      addSurveyQuestion: "Anket Sorusu Ekle",
      editSurveyQuestion: "Anket Sorusunu Düzenle",
      questionScore: "Soru Puanı",
      mandatory: "Zorunlu",
      yes: "Evet",
      no: "Hayır",
      options: "Seçenekler",
      typeHere: "Buraya yazın",
      add: "Ekle",
      optionsHint:
        "Bir yanıt eklemek için lütfen yazın veya Ekle düğmesine tıklayın",
      surveyProgress: "Devam Eden Anket",
      allResponses: "Tüm Yanıtlar Özeti",
      responseQuestion: "Sorulara Göre Yanıtlar",
      dateSubmitted: "Gönderim Tarihi",
      answer: "Cevaplar",
      totalScore: "Toplam Puan",
      score: "Puan",
      singleSelection: "Tek Seçenek",
      multipleSelection: "Çoklu Seçim",
      if: "Eğer",
      then: "ise",
      noResponse: "Yanıt Yok",
      noSurveyFound: "Anket Bulunamadı",
      createNewSurvey:
        'Lütfen yukarıdaki "Anket Oluştur" düğmesini kullanarak anket oluşturun',
      cannotPublish: "Devre dışı bırakılmış bir anketi yayınlayamazsınız!",
      deleteSurveyWarn:
        "Anketi silmek istediğinizden emin misiniz? Silerseniz tüm anket soruları ve gönderileri kalıcı olarak silinecektir.",
      noQuestionFound: "Soru Bulunamadı",
      createQuestion:
        'Lütfen yukarıdaki "SORU EKLE" düğmesini kullanarak önce soru ekleyin',
      deleteQuestion: "Soruyu silmek istediğinizden emin misiniz?",
      applyChanges: "Bu değişiklikleri nasıl uygulamak istersiniz?",
      editFutureSurveys: "SADECE GELECEK ANKETLERİ DÜZENLE",
      editLiveSurveyOnly: "YALNIZCA CANLI ANKETİ DÜZENLE",
      surveyIsLive:
        "Lütfen dikkat edin, anket şu anda canlıdır ve bu sırada bir soruyu düzenlemek önceki gönderileri etkileyebilir. Herhangi bir sorun yaşamamak için soruları düzenlemek yerine anketin bir kopyasını oluşturmayı düşünebilirsiniz.",
      clickToCopy: "Anket Kopyası Oluşturmak İçin Buraya Tıklayın",
      applyChangesNow: "DEĞİŞİKLİKLERİ ŞİMDİ UYGULA",
      copySurvey: "Anketi Kopyala",
      changeCopySurveyName:
        "Kopyalanan anket sürümünün adını değiştirebilirsiniz.",
    },
    memberDataSection: {
      coffeeType: "Kahve Türü",
      buyingStationDetails: "Alım İstasyonu Detayları",
      buyingStationUsers: "Alım İstasyonu Kullanıcıları",
      activityLog: "Aktivite Günlüğü",
    },
    cropsReport: "Tarım Ürünleri Raporu",
    today: "Bugün",
    week: "Hafta",
    month: "Ay",
    year: "Yıl",
    all: "Hepsi",
    cropsStatistics: "Tarım İstatistikleri",
    crops: "Ürünler",
    acres: "Dönüm",
    totalPlantedArea: "Toplam Ekim Alanı",
    farmersChart: "Çiftçi Grafikleri",
    cropsName: "Ürün Adı",
    farmers: "Çiftçiler",
    farms: "Çiftlikler",
    planted: "Ekildi",
    plantedArea: "Ekilen Alan",
    harvested: "Hasat Edildi",
    yieldAcre: "Dönüm Başına Verim",
    selectCrop: "Ürün Seç",
    listByYield: "Verime Göre Listele",
    listByPlantedArea: "Ekilen Alan Göre Listele",
    equipmentReport: "Ekipman Raporu",
    equipmentChart: "Ekipman Grafikleri",
    selectFarmer: "Çiftçi Seç",
    equipmentName: "Ekipman Adı",
    region: "Bölge",
    counts: "Sayılar",
    large: "Büyük",
    medium: "Orta",
    small: "Küçük",
    listByFarmer: "Çiftçiye Göre Listele",
    rowsPerPage: "Sayfa Başına Satır",
    farmersReport: "Çiftçi Raporları",
    farmersStatistics: "Çiftçi İstatistikleri",
    averageFarmerLand: "Ortalama Çiftçi Arazi",
    largeFarmers: "Büyük Çiftçiler",
    mediumFarmers: "Orta Büyüklükte Çiftçiler",
    smallFarmers: "Küçük Çiftçiler",
    listByLand: "Araziye Göre Listele",
    listByFarm: "Çiftliğe Göre Listele",
    AvgLandAcre: "Ortalama Arazi/Dönüm",
    listbyCrop: "Ürüne Göre Listele",
    listbyZone: "Bölgeye Göre Listele",
    farmName: "Çiftlik Adı",
    zones: "Bölgeler",
    area: "Alan",
    goalsAchievedReport: "Hedeflerin Gerçekleştirildiği Rapor",
    listByCrops: "Ürünlere Göre Listele",
    goalsAchievedChart: "Hedeflerin Gerçekleştirildiği Grafik",
    goalsAchieved: "Gerçekleştirilen Hedefler",
    goalsFailed: "Başarısız Hedefler",
    successRate: "Başarı Oranı",
    achieved: "Gerçekleştirilen",
    equipment: "Ekipman",
    pests: "Zirai Zararlılar",
    regions: "Bölgeler",
    filterByCrops: "Ürünlere Göre Filtrele",
    searchCrops: "Ürünleri Ara",
    batchCode: "Seri Kodu",
    batchRating: "Seri Değerlendirmesi",
    MakeASelection: "Seçim Yapın",
    typeTotalCoffeeQuantity: "Toplam Kahve Miktarını Girin",
    typeHumidity: "Nem Düzeyini Girin",
    valueInPercent: "Yüzde Değeri",
    purchaseOrderRequired: "Satın Alma Siparişi Gereklidir",
    totalCoffeeCherryRequired: "Toplam Kahve Kirazı Gereklidir",
    processTypeRequired: "İşlem Türü Gereklidir",
    stationInfo: "İstasyon Bilgileri",
    purchaseOrders: "Satın Alma Siparişleri",
    processingBatch: "İşleme Serisi",
    processedCoffeeOutRequired: "İşlenmiş Kahve Çıkışı Gereklidir",
    lotNo: "Seri Numarası",
    addNewS: "Yeni Ekle",
    viewAll: "Tümünü Görüntüle",
    parchmentOut: "Döşeme Çıkışı",
    processingDone: "İşleme Tamamlandı",
    farmerLotID: "Çiftçi ve Lot Kimliği",
    weight: "Ağırlık",
    plantationSettings: "Tarım Ayarları",
    PlantationsEachFarmerCanCreate:
      "Her Çiftçinin Oluşturabileceği Tarım Alanı Sayısı",
    manageAdditionalPlantationRequests: "Ek Tarım Taleplerini Yönet",
    autoApprove: "Otomatik Onay",
    adminApprovalRequired: "Yönetici Onayı Gereklidir",
    close: "Kapat",
    new_user: "Yeni Kullanıcı",
    KGAcre: "Kg/Dönüm",
  },
  oma: {
    //land suitability
    landSuitibility: "Arazi Uygunluğu",
    landSuitibilityReport: "Arazi Uygunluk Raporu",
    generateNewReport: "Yeni Rapor Oluştur",
    operatorName: "Operatör Adı",
    issueDate: "Yayınlanma Tarihi",
    chooseYourLocation: "Konumunuzu Seçin",
    getLandEvaluation: "Arazi Değerlendirmesi Alın",
    downloadPdfReport: "PDF Raporunu İndir",
    pleaseEnterCoordinateText:
      "Lütfen çiftlik konumunun koordinatlarını (enlem ve boylam) girerek puanı görün.",
    noRecordAvailable: "Mevcut Kayıt Bulunmuyor.",
    overallScoreForLand: "Arazi Uygunluğu İçin Genel Puan",
    landEvaluation: "Arazi Değerlendirmesi",
    unsuitable: "Uygun Değil",
    marginally: "Kısmen",
    suitable: "Uygun",
    moderately: "Orta Derecede",
    highly: "Yüksek Derecede",
    back: "Geri",
    search: "Ara",
    showResults: "Sonuçları Göster",

    //weather analysis
    weatherAnalysisReport: "Hava Durumu Analiz Raporları",
    weatherAnalysis: "Hava Durumu Analizi",
    getWeatherAnalysis: "Hava Durumu Analizi Alın",
    weatherReport: "Hava Durumu Raporu",
    filterByDate: "Tarihe Göre Filtrele",
    insertCoordinateText:
      "Yukarıdaki çiftlik (veya ağaç) konumunun koordinatlarını girin veya aşağıdaki haritayı kullanarak çiftlik (veya ağaç) konumunu belirtin.",
    addTreeGeolocation: "Ağaç Konumunu Ekle",
    editTreeGeolocation: "Ağaç Konumunu Düzenle",
    plantationDate: "Ekim Tarihi",
    notes: "Notlar",
    uploadTreeImages: "Ağaç Resimlerini Yükle",

    valueAtTheCoordinatesOfInterest: "İlgili Koordinattaki Değer",
    "Slope (%)": "Eğim (%)",
    "Soil texture (USDA class)": "Toprak Dokusu (USDA Sınıfı)",
    "Coarse fragments (vol%)": "Kaba Parçalar (hacim%)",
    Land: "Arazi",
    "Artificial surfaces (type)": "Yapay Yüzeyler (tip)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Tip 1 ve 2 Yollara Yakınlık (metre)",
    "Soil Chemical Properties": "Toprak Kimyasal Özellikleri",
    "Soil Physical Properties": "Toprak Fiziksel Özellikleri",
    "Soil organic carbon (%)": "Toprak Organik Karbon (%)",
    "Soil pH": "Toprak pH",
    "Soil salinity (ECe))": "Toprak Tuzluluğu (ECe)",
    "Mean annual temperature (°C)": "Yıllık Ortalama Sıcaklık (°C)",
    Weather: "Hava Durumu",
    "Mean minimum temperature of coldest month (°C)":
      "En Soğuk Ayın Ortalama En Düşük Sıcaklığı (°C)",
    "Mean annual precipitation (mm)": "Yıllık Ortalama Yağış (mm)",
  },
  dueDiligence: {
    question: "Soru",
    answer: "Cevap",
    riskAssessment: "Risk Değerlendirmesi",
  },
  deforestation: {
    riskLevel: "Risk",
    eudrComplianceStatus: "EUDR Uygunluk Durumu",
    deforestationComplianceReport: "Orman Tahribatı Uygunluk Raporları",
    noDeforestationComplianceReport:
      "Orman Tahribatı Uygunluk Raporu Bulunamadı",
    loadingDeforestationComplianceReport:
      "Orman Tahribatı Uygunluk Raporu Yükleniyor",
    farmName: "Çiftlik Adı",
    farmRegistrationId: "Çiftlik Kayıt ID'si",
    farmerName: "Çiftçi Adı",
    farmerRegistrationId: "Çiftçi Kayıt ID'si",
    uniqueFarmerId: "Tekil Çiftçi ID'si",
    uniqueFarmId: "Tekil Çiftlik ID'si",
    farmLocation: "Çiftlik Konumu",
    area: "Alan",
    farmAddress: "Çiftlik Adresi",
    dateOfRequest: "Talep Tarihi",
    status: "Durum",
    settings: "Ayarlar",

    farmLatitude: "Çiftlik Enlemi",
    farmLongitude: "Çiftlik Boylamı",
    shareQRCode: "QR Kodu Paylaş",
    copy: "Kopyala",

    allCountries: "Tüm Ülkeler",
    allRegions: "Tüm Bölgeler",
    allFarms: "Tüm Çiftlikler",
    viewCertificate: "Sertifikayı Görüntüle",

    assignmentIssued: "Atama Yapıldı",

    complianceCertification: "Uygunluk Sertifikası",
    noComplianceCertification: "Uygunluk Sertifikası Bulunamadı",
    loadingComplianceCertification: "Uygunluk Sertifikası Yükleniyor",

    eudrForestAssessment: "EUDR Orman Değerlendirmeleri",
    assessmentReport: "Değerlendirme Raporu",
    downloadPDF: "PDF İndir",
    back: "Geri",
    farmDetails: "Çiftlik Detayları",

    dimitraFarmId: "Dimitra Çiftlik ID'si",
    dimitraFermerId: "Dimitra Çiftçi ID'si",

    totalGeofenceAreaHA: "Toplam Jeofens Alanı (HA)",
    forestLossHA: "Orman Kaybı (HA)",
    forestGainHA: "Orman Kazancı (HA)",
    forestUnchangedHA: "Değişmeyen Orman (HA)",
    shareCertificate: "Sertifikayı Paylaş",
    forestUnchanged: "Değişmeyen Orman",
    forestLoss: "Orman Kaybı",
    forestGain: "Orman Kazancı",
    totalGeofenceArea: "Toplam Jeofens Alanı",
    print: "Yazdır",
    deforestationProbability: "Ormancılık Olasılığı",
    colorCode: "Renk Kodu",
    geofenceArea: "Jeofens Alanı",
    percentageOfGeofenceArea: "Jeofens Alanının Yüzdesi",
    view: "Görünüm",
    customization: "Özelleştirme",
    recordsPerpage: "Sayfa Başına Kayıt",
    restoreDefault: "Varsayılanı Geri Yükle",
    apply: "Uygula",
    forestAssessmentHelp:
      "Bu rapor hakkında sorularınız varsa veya anlamak için yardıma ihtiyacınız varsa, Destek Masası üzerinden bizimle iletişime geçin.",
    overallDeforestationProbability: "Genel Ormancılık Olasılığı",
    zeroOrNegligible: "Sıfır/İhmal Edilebilir",
    high: "Yüksek",
    allStatus: "Tüm Durumlar",
    low: "Düşük",
    veryHigh: "Çok Yüksek",
    medium: "Orta",
    veryLow: "Çok Düşük",
    assessmentIssued: "Değerlendirme Yapıldı",
    certificateIssued: "Sertifika Verildi",
    assessmentNo: "Değerlendirme No",
    blockchainCertificateDesc:
      "Blockchain Sertifikası Doğrulama Hash'i, Sertifika Kabul Edildiğinde Mevcut Olacaktır",
    blockchainValidation: "Blockchain Sertifikası Doğrulama",
    openBlockchainPage: "Blockchain Sayfasını Aç",
    clickLinkDesc:
      "Blockchain üzerinde sertifikayı doğrulamak için yukarıdaki bağlantıya tıklayın",
    tooltip: {
      dimitraFarmId:
        "Dimitra sisteminde belirli bir çiftlikle ilişkilendirilen benzersiz kimlik.",
      farmName: "Çiftliğin belirlenen adı.",
      farmRegistrationId: "Çiftlik kayıt numarası.",
      farmLocation: "Çiftliğin belirli coğrafi koordinatları veya konumu.",
      dimitraFermerId:
        "Dimitra sistemindeki bireysel bir çiftçiye bağlı benzersiz bir kimlik.",
      farmerName: "Çiftlikten sorumlu kişinin kimliği.",
      farmerRegistrationId: "Çiftçi kayıt numarası.",
      assessmentNo: "Değerlendirme için atanan benzersiz numara.",
    },
    red: "Kırmızı",
    Yellow: "Sarı",
    transparent: "Şeffaf",
    darkRed: "Koyu Kırmızı",
    brightRed: "Parlak Kırmızı",
    orange: "Turuncu",
    lightBlue: "Açık Mavi",
    teal: "Turkuaz",
    zeroOrNegligibleProbability: "Sıfır/İhmal Edilebilir Ormancılık Olasılığı",
    riskDetected: "Risk Tespit Edildi",
    zeroOrNegligibleRisk: "Sıfır/İhmal Edilebilir Risk",
        manuallyMitigated: "Manuel Olarak Azaltıldı",
    compliant: "Uyumlu",
    nonCompliant: "Uyumsuz",
    veryLowProbability: "Çok Düşük Ormancılık Olasılığı",
    lowProbability: "Düşük Ormancılık Olasılığı",
    mediumProbability: "Orta Ormancılık Olasılığı",
    highProbability: "Yüksek Ormancılık Olasılığı",
    veryHighProbability: "Çok Yüksek Ormancılık Olasılığı",
    locationName: "Konum Adı",
  },
  noUploadToBlockchain: "Blockchain'e Yükleme Yok",
  noDataForBlockchain: "Üretim yerleri için ormansızlaşma raporları oluşturulmadığından, blockchain'e yazılacak veri yoktu. Bu beklenmedik bir durumsa, lütfen çiftlikler için raporların önceki adımlarda doğru şekilde oluşturulduğundan emin olun.",
  pleaseAgreeToDeclaration: "Lütfen sonuçlandırmak için beyanı kabul edin.",
  importProductionPlaceTT: "Kullanıcıların dosya yükleme veya indirme seçeneklerini kullanarak üretim yeri verilerini içe aktarmasına olanak tanır.",
  defaultCircularGeofence: "Jeofens veya boyutları hakkında bilgi olmayan çiftliklere 4 hektarlık varsayılan dairesel jeofens atanacaktır. Ortalama çiftlik boyutu 4 hektardan küçükse, lütfen aşağıdaki 'Düzenle' düğmesine tıklayarak varsayılan boyutu değiştirin.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "EUDR'ye göre, 4 hektardan küçük çiftliklerin çokgen gerektirmez.",
  uploadOneDeforestationAssessmentForAllFarms: "TÜM ÇİFTLİKLER İÇİN BİR ORMAN KESİMİ DEĞERLENDİRMESİ YÜKLEYİN",
  uploadAssessment: "Değerlendirme Yükle"
};
